import { Users, Landmark, Tag, User, Building2, Network } from "lucide-react";

export const KINDS = {
  clubs: {
    key: "clubs", label: "Clubs", singular: "Club", path: "/clubs", filter: "club", icon: Users,
    newLabel: "Nouveau club", intro: "Des cercles de pairs qui se réunissent régulièrement autour d'un métier.",
  },
  commissions: {
    key: "commissions", label: "Commissions", singular: "Commission", path: "/commissions", filter: "commission",
    icon: Landmark, newLabel: "Nouvelle commission", intro: "Des groupes de travail thématiques animés par La Mêlée.",
  },
  groupes: {
    key: "groupes", label: "Pôles & sous-groupes", singular: "Groupe", path: "/groupes", filter: "group",
    icon: Network, newLabel: "Nouveau sous-groupe", intro: "Pôles, sous-groupes et groupes de travail de l'écosystème La Mêlée.",
  },
};

export const ENTITY = {
  person: { label: "Personne", icon: User, cls: "bg-blue-50 text-blue-700 border-blue-200" },
  organization: { label: "Entreprise", icon: Building2, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  clubs: { label: "Club", icon: Users, cls: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200" },
  commissions: { label: "Commission", icon: Landmark, cls: "bg-orange-50 text-orange-700 border-orange-200" },
  groupes: { label: "Groupe", icon: Network, cls: "bg-violet-50 text-violet-700 border-violet-200" },
  expertises: { label: "Expertise", icon: Tag, cls: "bg-teal-50 text-teal-700 border-teal-200" },
};
